/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, ENAX){
	const a = 'is-active';
	const $path = location.pathname;
	let $head = '/journal/';
	if($path.indexOf('/en/') !== -1) {
		$head = '/en/journal/';
	}

	// <共通>
	const searchKeywords = () => {
		if($('.js-keywordInput').length) {
			const $input = $('.js-keywordInput');
			const $form = $('.js-searchForm');

			$form.on('submit', (e) => {
				e.preventDefault();
				const keywords = $input.val().replaceAll(' ', '　').split('　');

				const searchParams = new URLSearchParams(location.search);
				const newSearchParams = new URLSearchParams();
				keywords.forEach((item, idx) => {
					if(idx < 5) {
						newSearchParams.set(`p_keyword_${idx + 1}`, item);
					}
				});

				location.href = `${$head}search.html?${newSearchParams.toString()}`;
			});

			// 検索結果
			if ($path === $head + 'search.html') {
				let $search = location.search;
				// inputに検索ワードを反映
				let paramArr = $search.split('&');
				let keywordsArr = [];
				for (let i = 0; i < paramArr.length; i++) {
					keywordsArr.push(paramArr[i].split('=')[1].replace('+', ' '));
				}
				keywordsArr = keywordsArr.filter(Boolean);
				$input.val(decodeURI(keywordsArr.join('　')));
			}
		}
	}

	// <詳細ページ>関連記事
	const detailRelationItem = () => {
		if($('.js-relation-item').length) {
			// カテゴリ取得
			let detailCat = $('.js-detail-category .rt_cf_n_category_code').text();
			// 「関連記事」内の自分を削除
			$('.js-relation-item .mod-boxLink01-link[href="'+$path+'"]').parents('.js-relation-item').remove();

			$('.js-relation-item').each((idx,ele) => {
				let thisCat = $(ele).find('.rt_cf_n_category_code').text();
				// 3件まで表示
				if($('.js-relation-item').not('.di_none').length < 3) {
					if(thisCat === detailCat) {
						$(ele).removeClass('di_none');
					}
				}
			});
			if(!$('.js-relation-item').not('.di_none').length) {
				$('.js-relation-wrap').remove();
			}
		}
	}

	// ============================================
	searchKeywords();
	if($path.indexOf('/detail/') !== -1) {
		detailRelationItem();
	}

})(window.jQuery, window.ENAX);
